import React from "react";
import Modal from "./Modal";

/**
 * Se encarga de construir un modal dialog que permite desplegar
 * mensajes.
 */
export default class Alert extends React.Component {
  /**
   * Almacena del estado del componente
   */
  state = {};
  /**
   * Referencia al modal
   */
  modal = React.createRef();

  /**
   * Cuando se renderiza el componete se setea la referencia al
   * componente.
   */
  componentDidMount() {
    this.props.onRef(this);
  }

  /**
   * Se encarga de mostrar el dialgo.
   */
  open = data => {
    this.setState({
      title: data.title,
      message: data.message
    });
    this.modal.open();
  };

  /**
   * Se encarga de manejar el close del dialog.
   */
  close = () => {
    this.modal.close();
  };

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    const { title, message } = this.state;
    return (
      <Modal title={title} onRef={ref => (this.modal = ref)}>
        <section className="modal-card-body">
          <p>{message}</p>
        </section>
        <footer className="modal-card-foot">
          <button onClick={evt => this.close()} className="button">
            Aceptar
          </button>
        </footer>
      </Modal>
    );
  }
}
